export const SESSION_STATUS_DROPDOWN_OPTIONS = [
  { key: 'processed', text: 'Processed', value: 'processed' },
  { key: 'processing', text: 'Processing', value: 'processing' },
  { key: 'transcribe_error', text: 'Transcribe Error', value: 'transcribe_error' },
  { key: 'pending', text: 'Pending', value: 'pending' },
];

export const COLUMNS = {
  workspace: 'Workspace',
  project: 'Project',
  testerName: 'Tester',
  sessionId: 'Session ID',
  status: 'Status',
  actions: 'Actions',
};

export const TOAST_TIME = 2200;
